import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Hoe snel krijg ik een offerte?", a: "Stuur je aanvraag met foto door en wij reageren binnen 2 uur tijdens werkuren met een vaste, eerlijke prijs. De offerte is altijd gratis en vrijblijvend." },
  { q: "Wat nemen jullie allemaal mee?", a: "Meubels, volledige inboedels, tuinafval, elektronica, metaal en grof huisvuil. Twijfel je? Stuur gewoon een foto mee, dan kijken wij." },
  { q: "Moet ik zelf iets dragen of buiten zetten?", a: "Nee. Wij halen alles op waar het staat — ook van verdiepingen, uit de kelder of uit de tuin. Jij hoeft nergens aan te komen." },
  { q: "Wat gebeurt er met mijn spullen?", a: "We sorteren alles: herbruikbare spullen krijgen een tweede leven, materialen worden gerecycleerd en enkel echte restafval gaat naar het containerpark. Zo bereiken we 95% hergebruik en recycling." },
  { q: "In welke regio's werken jullie?", a: "Wij zijn actief in heel België. Ophaling kan vaak al binnen 24 uur na goedkeuring van de offerte." },
];

export default function Faq() {
  return (
    <section id="faq" className="border-t border-white/10 bg-coal/50" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5 py-20 lg:px-8 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand">// Veelgestelde vragen</p>
          <h2 className="mt-3 font-display text-4xl font-black uppercase tracking-tight text-paper sm:text-5xl">
            Eerst weten, <span className="text-outline">dan doen</span>
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-10"
        >
          <Accordion type="single" collapsible>
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
                <AccordionTrigger className="font-display text-lg font-bold uppercase tracking-wide text-paper hover:text-safety hover:no-underline" data-testid={`faq-question-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted2" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
